import { pick } from './utils';
export const isUsingStyleProperties = (compStyle, keys) => {
    return keys.every(key => Boolean(compStyle[key]));
};
export const getMigratedStyleProps = ({ compProps, styleProperties, migratedFields, }) => {
    return Object.assign(Object.assign({}, pick(compProps, migratedFields)), pick(styleProperties, migratedFields));
};
//# sourceMappingURL=scaleProportionally.js.map